export default [
  {
    title: 'Api Fail',
    icon: 'CloudOffIcon',
    route: 'api-fail',
    resource: 'api',
    action: ['read', 'update'],
  },
]
